import styled from 'styled-components'

import { fontFamily } from '../../common/grid'

const StyledCalendarHeader = styled('div').attrs({
	className: 'calendar-header-week position-relative d-flex justify-content-center align-items-center',
})`
  width: 100%;

  .day {
    font:
      400 0.75rem/1 ${fontFamily},
      "Segoe UI",
      sans-serif;
    color: rgba(77, 118, 161, 1);
  }
`

export const StyledCalendarHeaderWeek = styled(StyledCalendarHeader)`
  &.week-highlighted {
    border-top: 3px solid var(--heeros-purple-600-brand);
  }

  .year,
  .day {
    position: absolute;
    top: 0.25rem;
    left: 0.5rem;
    font:
      400 0.75rem/1 ${fontFamily},
      "Segoe UI",
      sans-serif;
    color: rgba(77, 118, 161, 1);
  }

  .day {
    position: relative;
    top: auto;
    label: auto;
  }

  .month {
    padding: 0.5rem 0;
    font:
      600 13px/1 ${fontFamily},
      "Segoe UI",
      sans-serif;
    color: var(--heeros-blue-600-brand);
  }
`

export const StyledCalendarHeaderDay = styled(StyledCalendarHeader)`
  gap: 4px;
  padding: 0 3px;
  overflow: hidden;

  .day-holiday, .holiday-name {
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontFamily}, "Segoe UI", sans-serif;
    color: #003a78;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex-shrink: 1;
  }

  /* Tooltip shown on hover for public holidays — uses ::before to avoid
     conflicting with the ::after today-indicator underline */
  &[data-holiday] {
    cursor: default;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: rgba(255, 202, 221, 1);
    }

    &::before {
      content: attr(data-holiday);
      position: absolute;
      top: calc(100% + 6px);
      left: 50%;
      transform: translateX(-50%);
      background-color: rgba(33, 37, 41, 0.88);
      color: #fff;
      font-size: 11px;
      font-family: ${fontFamily}, "Segoe UI", sans-serif;
      white-space: nowrap;
      padding: 3px 8px;
      border-radius: 4px;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.15s ease;
      z-index: 9999;
    }

    &:hover::before {
      opacity: 1;
    }
  }

  &.day-now {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: var(--heeros-purple-600-brand);
    }
  }
`

export const CalendarHeaderWeek = ({ isCurrent, isFocused, isInRange, year, month }) => (
	<StyledCalendarHeaderWeek className={isCurrent || isFocused || isInRange ? 'week-highlighted' : ''}>
		<div className="year">{year}</div>
		<div className="month">{month}</div>
	</StyledCalendarHeaderWeek>
)

export const CalendarHeaderDay = ({ isCurrent, day, isHoliday, holidayName }) => (
	<StyledCalendarHeaderDay
		className={isCurrent ? 'day-now' : ''}
		{...(holidayName ? { 'data-holiday': holidayName } : {})}
	>
		<div className={`day${isHoliday ? ' day-holiday' : ''}`}>{day}</div>
		{holidayName && <div className="holiday-name">{holidayName}</div>}
	</StyledCalendarHeaderDay>
)
